import {
    CHALLENGE_PAGE_FETCH_AUTO_CHALLENGE_DONE,
    CHALLENGE_PAGE_FETCH_AVAILABLE_BADGE_CHALLENGES,
    CHALLENGE_PAGE_FETCH_AVAILABLE_BADGE_CHALLENGES_DONE,
    CHALLENGE_PAGE_FETCH_BADGE_DETAIL,
    CHALLENGE_PAGE_FETCH_BADGE_DETAIL_DONE,
    CHALLENGE_PAGE_FETCH_VIRTUAL_CHALLENGES,
    CHALLENGE_PAGE_FETCH_VIRTUAL_CHALLENGES_DONE,
    CHALLENGE_PAGE_FETCH_CURRENT_CHALLENGES,
    CHALLENGE_PAGE_FETCH_CURRENT_CHALLENGES_DONE,
    CHALLENGE_PAGE_FETCH_PAST_CHALLENGES,
    CHALLENGE_PAGE_FETCH_PAST_CHALLENGES_DONE,
    CHALLENGE_PAGE_INIT,
    CHALLENGE_PAGE_JOIN_BADGE_CHALLENGE,
    CHALLENGE_PAGE_JOIN_BADGE_CHALLENGE_DONE,
    CHALLENGE_PAGE_OPT_IN_VIRTUAL_CHALLENGE_DONE,
    CHALLENGE_PAGE_OPT_OUT_AUTO_CHALLENGE,
    CHALLENGE_PAGE_RESET,
    CHALLENGE_PAGE_SET_BADGE_DETAIL_DIALOG_OPEN,
    CHALLENGE_PAGE_SET_OPT_OUT_DIALOG,
    CHALLENGE_PAGE_SET_ROUTE,
    CHALLENGE_PAGE_UPDATE_AVAILABLE_BADGE_CHALLENGE,
    CHALLENGE_PAGE_VIRTUAL_CHALLENGE_DETAIL_INIT,
    CHALLENGE_PAGE_VIRTUAL_CHALLENGE_DETAIL_INIT_DONE,
    CHALLENGE_PAGE_UNDO_JOIN_BADGE_CHALLENGE,
    CHALLENGE_PAGE_OPT_IN_VIRTUAL_CHALLENGE_ERROR_ACK,
    CHALLENGE_PAGE_SET_PRE_JOIN_CONFIRM_DIALOG_STATE
} from '../../actions/ActionTypes';

import { PRE_JOIN_CONFIRM_DIALOG_TYPE, NOTIFICATION_STATUS } from 'ChallengePage/challengePageUiConstants';

const INITIAL_STATE = {
    viewerSocialProfile: null,
    route: null,
    badgeChallenge: {
        error: false,
        fetching: true,
        limit: -1,
        list: null,
        hasMore: false,
        processing: [],
        notificationStatus: NOTIFICATION_STATUS.CLOSED,
        lastJoined: null
    },
    virtualChallenge: {
        error: false,
        fetching: true,
        limit: -1,
        list: null,
        hasMore: false
    },
    virtualChallengeDetail: {
        challengeUuid: null,
        fetching: true,
        error: false,
        challenge: null,
        optInError: false
    },
    badgeDetail: {
        badge: null,
        open: false,
        fetchng: true
    },
    currentChallenge: {
        error: false,
        fetching: true,
        limit: -1,
        autoChallenge: null,
        groupChallenges: null,
        adHocChallenges: null,
        vivokidChallenges: null,
        teamStepsVivokidChallenges: null,
        badgeChallenges: null,
        virtualChallenges: null
    },
    optOutDialog: {
        open: false,
        submitting: false
    },
    pastChallenge: {
        error: false,
        fetching: true,
        limit: -1,
        autoChallenge: null,
        groupChallenges: null,
        adHocChallenges: null,
        vivokidChallenges: null,
        teamStepsVivokidChallenges: null,
        badgeChallenges: null,
        virtualChallenges: null
    },
    preJoinConfirmDialog: {
        open: false,
        submitting: false,
        dialogType: PRE_JOIN_CONFIRM_DIALOG_TYPE.NONE,
        challenge: null,
        confirmed: [],
        hasSubscribed: null
    }
};

/** selectors */
export const selectChallengePage = (state) => state.challengePage || INITIAL_STATE;

export const selectViewerSocialProfile = (state) => {
    const challengePage = selectChallengePage(state);
    return challengePage.viewerSocialProfile;
};

export const selectChallengePageRoute = (state) => {
    const challengePage = selectChallengePage(state);
    return challengePage.route;
};

export const selectChallengePageBadgeChallengeState = (state) => {
    const challengePage = selectChallengePage(state);
    return challengePage.badgeChallenge;
};

export const selectChallengePageVirtualChallengeState = (state) => {
    const challengePage = selectChallengePage(state);
    return challengePage.virtualChallenge;
};

export const selectChallengePageVirtualChallengeDetailState = (state) => {
    const challengePage = selectChallengePage(state);
    return challengePage.virtualChallengeDetail;
};

export const selectChallengePageBadgeDetailState = (state) => {
    const challengePage = selectChallengePage(state);
    return challengePage.badgeDetail;
};

export const selectChallengePageCurrentChallengeState = (state) => {
    const challengePage = selectChallengePage(state);
    return challengePage.currentChallenge;
};

export const selectChallengePageOptOutDialog = (state) => {
    const challengePage = selectChallengePage(state);
    return challengePage.optOutDialog;
};

export const selectChallengePagePastChallengeState = (state) => {
    const challengePage = selectChallengePage(state);
    return challengePage.pastChallenge;
};

export const selectChallengePagePreJoinConfirmDialogState = (state) => {
    const challengePage = selectChallengePage(state);
    return challengePage.preJoinConfirmDialog;
};

/** handlers */
const challengePageInit = (_, action) => {
    return {
        ...INITIAL_STATE,
        viewerSocialProfile: action.viewerSocialProfile,
        route: action.route
    };
};

const challengePageReset = () => {
    return {
        ...INITIAL_STATE
    };
};

const challengePageSetRoute = (state, action) => {
    return {
        ...state,
        route: action.route
    };
};

const challengePageFetchAvailableBadgeChallenges = (state, action) => {
    return {
        ...state,
        badgeChallenge: {
            error: false,
            fetching: true,
            list: null,
            hasMore: false,
            limit: action.limit,
            processing: [],
            notificationStatus: NOTIFICATION_STATUS.CLOSED
        }
    };
};

const challengePageFetchAvailableBadgeChallengesDone = (state, action) => {
    return {
        ...state,
        badgeChallenge: {
            ...state.badgeChallenge,
            error: action.error,
            fetching: false,
            list: action.list,
            hasMore: action.hasMore
        }
    };
};

const challengePageUpdateAvailableBadgeChallenge = (state, action) => {
    if (!action.challenge || !action.challenge.uuid) {
        return state;
    }
    const newList = state.badgeChallenge.list;
    if (!Array.isArray(newList)) {
        return state;
    }
    const index = newList.findIndex((item) => item.uuid === action.challenge.uuid);
    if (index < 0) {
        return state;
    }
    newList.splice(index, 1, action.challenge);
    return {
        ...state,
        badgeChallenge: {
            ...state.badgeChallenge,
            list: newList
        }
    };
};

const challengePageJoinBadgeChallenge = (state, action) => {
    let newProcessing = state.badgeChallenge.processing;
    if (!newProcessing.includes(action.challenge.uuid)) {
        newProcessing.push(action.challenge.uuid);
    }
    return {
        ...state,
        badgeChallenge: {
            ...state.badgeChallenge,
            processing: newProcessing,
            notificationStatus: NOTIFICATION_STATUS.CLOSED,
            lastJoined: null
        }
    };
};

const challengePageJoinBadgeChallengeDone = (state, action) => {
    let newProcessing = state.badgeChallenge.processing;
    newProcessing = newProcessing.filter((item) => item !== action.challenge.uuid);
    return {
        ...state,
        badgeChallenge: {
            ...state.badgeChallenge,
            processing: newProcessing,
            notificationStatus: action.error ? NOTIFICATION_STATUS.ERROR : NOTIFICATION_STATUS.SUCCEED,
            lastJoined: action.error ? null : action.challenge
        }
    };
};

const challengePageUndoJoinBadgeChallenge = (state) => {
    return {
        ...state,
        badgeChallenge: {
            ...state.badgeChallenge,
            notificationStatus: NOTIFICATION_STATUS.UNDO
        }
    };
};

const challengePageFetchVirtualChallenges = (state, action) => {
    return {
        ...state,
        virtualChallenge: {
            error: false,
            fetching: true,
            list: null,
            hasMore: false,
            limit: action.limit
        }
    };
};

const challengePageFetchVirtualChallengesDone = (state, action) => {
    return {
        ...state,
        virtualChallenge: {
            ...state.virtualChallenge,
            error: action.error,
            fetching: false,
            list: action.list,
            hasMore: action.hasMore
        }
    };
};

const challengePageVirtualChallengeDetailInit = (state, action) => {
    return {
        ...state,
        virtualChallengeDetail: {
            challengeUuid: action.challengeUuid,
            fetching: true,
            error: false,
            challenge: null,
            badgeDetail: null
        }
    };
};

const challengePageVirtualChallengeDetailInitDone = (state, action) => {
    return {
        ...state,
        virtualChallengeDetail: {
            ...state.virtualChallengeDetail,
            fetching: false,
            error: action.error,
            challenge: action.challenge
        }
    };
};

const challengePageSetBadgeDetailDialogOpen = (state, action) => {
    return {
        ...state,
        badgeDetail: {
            ...state.badgeDetail,
            open: action.open
        }
    };
};

const challengePageFetchBadgeDetail = (state) => {
    return {
        ...state,
        badgeDetail: {
            ...state.badgeDetail,
            badge: null,
            fetching: true
        }
    };
};

const challengePageFetchBadgeDetailDone = (state, action) => {
    return {
        ...state,
        badgeDetail: {
            ...state.badgeDetail,
            badge: action.badge,
            fetching: false
        }
    };
};

const challengePageOptInVirtualChallengeDone = (state, action) => {
    if (action.error && action.tooMany) {
        return {
            ...state,
            virtualChallengeDetail: {
                ...state.virtualChallengeDetail,
                optInError: true,
                challenge: {
                    ...state.virtualChallengeDetail.challenge,
                    joinable: false
                }
            }
        };
    }
    if (action.error) {
        return state;
    }
    return {
        ...state,
        virtualChallengeDetail: {
            ...state.virtualChallengeDetail,
            challenge: {
                ...state.virtualChallengeDetail.challenge,
                joinDateLocal: new Date().toISOString(),
                userJoined: true
            }
        }
    };
};

const challengePageOptInVirtualChallengeErrorAck = (state) => {
    return {
        ...state,
        virtualChallengeDetail: {
            ...state.virtualChallengeDetail,
            optInError: false
        }
    };
};

const challengePageFetchCurrentChallenges = (state, action) => {
    return {
        ...state,
        currentChallenge: {
            error: false,
            fetching: true,
            limit: action.limit,
            autoChallenge: null,
            groupChallenges: null,
            adHocChallenges: null,
            vivokidChallenges: null,
            teamStepsVivokidChallenges: null,
            badgeChallenges: null,
            virtualChallenges: null
        }
    };
};

const challengePageFetchCurrentChallengesDone = (state, action) => {
    return {
        ...state,
        currentChallenge: {
            ...state.currentChallenge,
            fetching: false,
            error: action.error,
            autoChallenge: action.autoChallenge,
            groupChallenges: action.groupChallenges,
            adHocChallenges: action.adHocChallenges,
            vivokidChallenges: action.vivokidChallenges,
            teamStepsVivokidChallenges: action.teamStepsVivokidChallenges,
            badgeChallenges: action.badgeChallenges,
            virtualChallenges: action.virtualChallenges
        }
    };
};

const challengePageFetchAutoChallengeDone = (state, action) => {
    return {
        ...state,
        currentChallenge: {
            ...state.currentChallenge,
            autoChallenge: action.autoChallenge
        }
    };
};

const challengePageSetOptOutDialog = (state, action) => {
    return {
        ...state,
        optOutDialog: {
            open: action.open,
            submitting: action.submitting
        }
    };
};

const challengePageOptOutAutoChallenge = (state, action) => {
    return {
        ...state,
        optOutDialog: {
            ...state.optOutDialog,
            submitting: true
        }
    };
};

const challengePageFetchPastChallenges = (state, action) => {
    return {
        ...state,
        pastChallenge: {
            error: false,
            fetching: true,
            limit: action.limit,
            autoChallenge: null,
            groupChallenges: null,
            adHocChallenges: null,
            vivokidChallenges: null,
            teamStepsVivokidChallenges: null,
            badgeChallenges: null,
            virtualChallenges: null
        }
    };
};

const challengePageFetchPastChallengesDone = (state, action) => {
    return {
        ...state,
        pastChallenge: {
            ...state.pastChallenge,
            fetching: false,
            error: action.error,
            autoChallenge: action.autoChallenge,
            groupChallenges: action.groupChallenges,
            adHocChallenges: action.adHocChallenges,
            vivokidChallenges: action.vivokidChallenges,
            teamStepsVivokidChallenges: action.teamStepsVivokidChallenges,
            badgeChallenges: action.badgeChallenges,
            virtualChallenges: action.virtualChallenges
        }
    };
};

const challengePageSetPreJoinConfirmDialogState = (state, action) => {
    return {
        ...state,
        preJoinConfirmDialog: {
            ...state.preJoinConfirmDialog,
            open: action.open,
            submitting: action.submitting || state.preJoinConfirmDialog.submitting,
            dialogType: action.dialogType || state.preJoinConfirmDialog.dialogType,
            challenge: action.challenge,
            confirmed: [...action.confirmed],
            hasSubscribed: action.hasSubscribed
        }
    };
};

const handlers = {
    [CHALLENGE_PAGE_INIT]: challengePageInit,
    [CHALLENGE_PAGE_RESET]: challengePageReset,
    [CHALLENGE_PAGE_SET_ROUTE]: challengePageSetRoute,
    [CHALLENGE_PAGE_FETCH_AVAILABLE_BADGE_CHALLENGES]: challengePageFetchAvailableBadgeChallenges,
    [CHALLENGE_PAGE_FETCH_AVAILABLE_BADGE_CHALLENGES_DONE]: challengePageFetchAvailableBadgeChallengesDone,
    [CHALLENGE_PAGE_UPDATE_AVAILABLE_BADGE_CHALLENGE]: challengePageUpdateAvailableBadgeChallenge,
    [CHALLENGE_PAGE_JOIN_BADGE_CHALLENGE]: challengePageJoinBadgeChallenge,
    [CHALLENGE_PAGE_JOIN_BADGE_CHALLENGE_DONE]: challengePageJoinBadgeChallengeDone,
    [CHALLENGE_PAGE_FETCH_VIRTUAL_CHALLENGES]: challengePageFetchVirtualChallenges,
    [CHALLENGE_PAGE_FETCH_VIRTUAL_CHALLENGES_DONE]: challengePageFetchVirtualChallengesDone,
    [CHALLENGE_PAGE_VIRTUAL_CHALLENGE_DETAIL_INIT]: challengePageVirtualChallengeDetailInit,
    [CHALLENGE_PAGE_VIRTUAL_CHALLENGE_DETAIL_INIT_DONE]: challengePageVirtualChallengeDetailInitDone,
    [CHALLENGE_PAGE_SET_BADGE_DETAIL_DIALOG_OPEN]: challengePageSetBadgeDetailDialogOpen,
    [CHALLENGE_PAGE_FETCH_BADGE_DETAIL]: challengePageFetchBadgeDetail,
    [CHALLENGE_PAGE_FETCH_BADGE_DETAIL_DONE]: challengePageFetchBadgeDetailDone,
    [CHALLENGE_PAGE_OPT_IN_VIRTUAL_CHALLENGE_DONE]: challengePageOptInVirtualChallengeDone,
    [CHALLENGE_PAGE_FETCH_CURRENT_CHALLENGES]: challengePageFetchCurrentChallenges,
    [CHALLENGE_PAGE_FETCH_CURRENT_CHALLENGES_DONE]: challengePageFetchCurrentChallengesDone,
    [CHALLENGE_PAGE_FETCH_AUTO_CHALLENGE_DONE]: challengePageFetchAutoChallengeDone,
    [CHALLENGE_PAGE_SET_OPT_OUT_DIALOG]: challengePageSetOptOutDialog,
    [CHALLENGE_PAGE_OPT_OUT_AUTO_CHALLENGE]: challengePageOptOutAutoChallenge,
    [CHALLENGE_PAGE_FETCH_PAST_CHALLENGES]: challengePageFetchPastChallenges,
    [CHALLENGE_PAGE_FETCH_PAST_CHALLENGES_DONE]: challengePageFetchPastChallengesDone,
    [CHALLENGE_PAGE_UNDO_JOIN_BADGE_CHALLENGE]: challengePageUndoJoinBadgeChallenge,
    [CHALLENGE_PAGE_OPT_IN_VIRTUAL_CHALLENGE_ERROR_ACK]: challengePageOptInVirtualChallengeErrorAck,
    [CHALLENGE_PAGE_SET_PRE_JOIN_CONFIRM_DIALOG_STATE]: challengePageSetPreJoinConfirmDialogState
};

export default function challengePageReducer(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) {
        return state;
    }
    return handler(state, action);
}
